import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DocumentMD = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M4 7.5L4 4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V7.5M20 16.5V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20L4 16.5"
          stroke={color}
        />
        <path
          d="M3 8.5C3 7.94772 3.44772 7.5 4 7.5H20C20.5523 7.5 21 7.94772 21 8.5V15.5C21 16.0523 20.5523 16.5 20 16.5H4C3.44772 16.5 3 16.0523 3 15.5V8.5Z"
          stroke={color}
        />
        <path
          d="M6.37246 9.18182H7.66223L9.3895 13.3977H9.45768L11.185 9.18182H12.4747V15H11.4634V11.0028H11.4094L9.80143 14.983H9.04575L7.4378 10.9943H7.38382V15H6.37246V9.18182ZM16.8101 9.18182V13.446L18.4209 11.8295L19.0118 12.4148L16.3868 15.0341L13.7675 12.4148L14.347 11.8295L15.9635 13.446V9.18182H16.8101Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DocumentMD
